import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import logo from '../../Assets/memlogo.png'
import './mobileNavbar.css'

const MobileNavbar=()=>{
    const [showNavbar,setShowNavbar]=React.useState(true)
    const location=useLocation();

    const { user, loginWithRedirect, logout, isAuthenticated } = useAuth0();
    const navigate = useNavigate();
    const serverName="https://api.myemployeemanual.com";

     function accButton(){
        if (isAuthenticated) {
            return(
            <Link to="/account" className='tab'><p>Account</p></Link>
            );
        }else{
        return(<div></div>);
        }
    }

    function checkAuth(){
        if (isAuthenticated) {
            return "Sign Out"
        } else {
            return "Sign In"
        }
    }

    function handleNavbar(){
        if (showNavbar){
            return(
                <div className='shownDropdown'>
                    <Link to="/" className='tab'><p>Home</p></Link>
                    {/*<Link to="/about" className='tab'><p>About Us</p></Link>*/}
                    {/*<Link to="/blog" className='tab'><p>Blog</p></Link>*/}
                    <Link to="/contact" className='tab'><p>Contact Us</p></Link>
                    {accButton()}
                    <button onClick={() => isAuthenticated ? logout() : loginWithRedirect()} className='login'><p>{checkAuth()}</p></button>
                </div>
            )
        }
        return(<div></div>)
    }
    function handleNavbarShow(){
        setShowNavbar(!(showNavbar))
    }
    
    return(
        <div className='mobileNavbar'>
            <div className='navbarHeader'>
                <Link to="/">
                    <img src={logo} alt='MEM Logo' className="logo"/>
                </Link>
                <div className='navbarRight'>
                    <button onClick={() => handleNavbarShow()} className='tab'><p>☰</p></button>
                </div>
            </div>
            {handleNavbar()}
        </div>
    )
}

export default MobileNavbar